import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  // color
  palette: {
    primary: {
      main: '#494949',
    },
    secondary: {
      main: '#045ea8',
    },
  },

  typography: {
    h2: {
      fontFamily: 'GenYOGothic2TW',
      fontSize: '3.6rem',
      fontWeight: 'bold',
      lineHeight: '4rem',
      color: '#494949',
    },
    h3: {
      fontFamily: 'GenYOGothic2TW',
      fontSize: '2.4rem',
      fontWeight: 'bold',
      lineHeight: '3rem',
      color: '#494949',
    },
    h4: {
      fontFamily: 'GenYOGothic2TW',
      fontSize: '1.8rem',
      fontWeight: 'bold',
      color: '#494949',
      lineHeight: '2.1rem',
    },
    subtitle1: {
      fontFamily: 'GenYOGothic2TW',
      fontSize: '1.5rem',
      fontWeight: '500',
      lineHeight: '2rem',
      color: '#5b5b5b',
    },
    body1: {
      fontFamily: 'GenYOGothic2TW',
      fontSize: '1.2rem',
      lineHeight: '1.5rem',
      color: '#5b5b5b',
    },
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1280,
      xl: 1536,
    },
  },
})

export default theme
